let recoveryToken = '';

export function captureRecoveryToken(browser) {
  if (!browser || browser.location.pathname !== '/reset-password') return;
  const fragment = browser.location.hash.slice(1);
  recoveryToken = /^[a-f0-9]{64}$/.test(fragment) ? fragment : '';
  browser.history.replaceState(browser.history.state, '', browser.location.pathname);
}

export function takeRecoveryToken() {
  const token = recoveryToken;
  recoveryToken = '';
  return token;
}

if (typeof window !== 'undefined') captureRecoveryToken(window);
